import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress, Alert, Button, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { publicService } from '../../services/api';

const statusText = {
  pending: 'Bekliyor (Onaylanmadı)',
  confirmed: 'Onaylandı',
  cancelled: 'Reddedildi / İptal Edildi',
  in_progress: 'İşlemde',
  completed: 'Tamamlandı'
};

const AppointmentConfirm = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [info, setInfo] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionResult, setActionResult] = useState(null);

  useEffect(() => {
    const fetchInfo = async () => {
      setLoading(true);
      try {
        const response = await publicService.mechanicConfirmInfo(token);
        setInfo(response.data.data);
        setResult({ success: true, message: response.data.message });
      } catch (error) {
        setResult({ success: false, message: error.response?.data?.message || 'Onay bilgisi alınamadı.' });
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchInfo();
  }, [token]);

  const handleAction = async (action) => {
    setActionLoading(true);
    setActionResult(null);
    try {
      const response = await publicService.mechanicConfirmAction(token, action);
      setActionResult({ success: true, message: response.data.message });
      // İşlem sonrası info'yu güncelle
      setInfo((prev) => ({ ...prev, status: action === 'approve' ? 'confirmed' : 'cancelled', mechanicConfirmedAt: new Date().toISOString() }));
    } catch (error) {
      setActionResult({ success: false, message: error.response?.data?.message || 'İşlem sırasında hata oluştu.' });
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', textAlign: 'center', mt: 8 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
          Randevu Onay / Red
        </Typography>
        {loading && <CircularProgress sx={{ mt: 4 }} />}
        {!loading && result && (
          <Alert
            severity={result.success ? 'info' : 'error'}
            icon={result.success ? <CheckCircleIcon fontSize="inherit" /> : <ErrorIcon fontSize="inherit" />}
            sx={{ mt: 2, fontSize: '1.1rem', justifyContent: 'center' }}
          >
            {result.message}
          </Alert>
        )}
        {!loading && info && (
          <Box sx={{ mt: 4 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Takip No: <b>{info.trackingNumber}</b>
            </Typography>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Tarih: {info.appointmentDate ? new Date(info.appointmentDate).toLocaleString('tr-TR') : '-'}
            </Typography>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Durum: <b>{statusText[info.status] || info.status}</b>
            </Typography>
            {info.mechanicConfirmedAt && (
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                Onay/Red Zamanı: {new Date(info.mechanicConfirmedAt).toLocaleString('tr-TR')}
              </Typography>
            )}
            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                color="success"
                disabled={actionLoading || info.status === 'confirmed' || info.status === 'cancelled'}
                onClick={() => handleAction('approve')}
              >
                Onayla
              </Button>
              <Button
                variant="contained"
                color="error"
                disabled={actionLoading || info.status === 'confirmed' || info.status === 'cancelled'}
                onClick={() => handleAction('reject')}
              >
                Reddet
              </Button>
            </Stack>
            {actionLoading && <CircularProgress sx={{ mt: 2 }} />}
            {actionResult && (
              <Alert
                severity={actionResult.success ? 'success' : 'error'}
                sx={{ mt: 3, fontSize: '1.1rem', justifyContent: 'center' }}
              >
                {actionResult.message}
              </Alert>
            )}
          </Box>
        )}
        <Box sx={{ mt: 4 }}>
          <Button variant="contained" color="primary" href="/" sx={{ mr: 2 }}>
            Ana Sayfa
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AppointmentConfirm; 